import { v4 as uuidv4 } from 'uuid';

export function summaryValidation (summary, date) {
    const summaryy = {
        status: false,
        templete: {
            id: uuidv4(),
            data: {},
            date: date,
            async: {
                status: "f",
                reason: "new"
            },
        }
    }
    const isValidDate = new Date(date);
    
    if(isNaN(isValidDate.getTime()) || !summary) {
        return summaryy;
    }
    
    summaryy.status = true;
    summaryy.templete.data = summary;
    
    return summaryy;
}